<!-- ~/components/ui/post/PostDocuments.vue -->
<script setup lang="ts">
import {type Media} from "~/repository/types";

const props = defineProps<{
  documents: Media[];
}>();

function getFileNameFromUrl(url: string): string {
  return decodeURIComponent(url.split("/").pop() || "Dokument");
}

async function downloadFile(url: string) {
  try {
    const response = await fetch(url, {mode: 'cors'});

    if (!response.ok) {
      throw new Error("Download failed");
    }

    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = getFileNameFromUrl(url);
    a.click();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download error:", error);
  }
}
</script>

<template>
  <div v-if="documents.length > 0" class="p-4 md:p-6">
    <div v-for="item in documents" :key="item.uuid">
      <Button
        variant="outline"
        size="xl"
        @click="downloadFile(item.url)"
        target="_blank"
        class="mb-2 p-3 hover:bg-neutral-100 transition-all duration-150 group flex items-center justify-between"
        :title="getFileNameFromUrl(item.url)"
      >
        <div class="flex items-center gap-2 truncate">
          <div
            class="w-7 h-7 group-hover:scale-[1.03] group-active:scale-[0.98] transition-transform duration-150 flex items-center justify-start">
            <Icon name="material-symbols:description" size="32" class="text-black"/>
          </div>
          <div class="truncate">{{ getFileNameFromUrl(item.url) }}</div>
        </div>

        <div class="ml-auto">
          <Icon name="mdi:download" size="18"/>
        </div>
      </Button>
    </div>
  </div>
</template>
